import React from "react";
import PropTypes from "prop-types";
import "./Tag.css"

const Tag = ({ text, color }) => {
  return <span className={`opp-tag ${color}`}>{text}</span>;
};

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default Tag;
